import SliderImageSeparator from "./common/SliderImageSeparator"
import TripleIconSection from "./common/TripleIconSection"
import ImageSectionItem from "./common/ImageSectionItem"
import IconTextSection from "./common/IconTextSection"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import { Link } from "react-router-dom"
import { useEffect } from "react"
import "./Services.css"

const Services = () => {

    useEffect(() => {
        document.title = 'Séneca - Servicios'
        window.scrollTo(0, 0)
    }, [])

    return (

        <main className="generic-main">

            <ImageTitleItem
                imageURL="/images/services/servicios-1.jpg"
                titleText="Todos nuestros recursos y conocimientos a su disposición"
                icon="bi bi-diagram-3-fill blue-icon"
                subtitleText="Es posible que no se necesiten todas las funcionalidades de Séneca, por lo que queremos ofrecer la posibilidad de adaptarlas a sus necesidades y contratarlas como servicios"
            />
            <SliderImageSeparator />

            <ImageSectionItem
                imageURL="/images/services/servicios-2.jpg"
                imagePosition="before"
                layout="row"
                title="Producción y streaming"
                textArray={[
                    "<p class='middle-section-label'><strong>Ofrecemos un servicio llave en mano para retransmitir sus actos de empresa o institucionales: nosotros nos encargamos de todo, simplemente fije fecha, lugar y duración del evento.</strong></p>",
                    "<p class='middle-section-label'>Con el servicio de <strong>Producción y Streaming</strong> es muy sencillo, proporcionamos todos los recursos necesarios y personal especializado para grabar y emitir desde donde quiera, cuando y como quiera. Nuestro <strong>Kit de Grabación</strong> incluye:</p>",
                    "<ul class='middle-section-label ml-50'><li><strong>Operario</strong></li><li><strong>Cámara</strong></li><li><strong>Gestión</strong></li><li><strong>Emisión</strong></li></ul>",
                    "<section class='padding-only'/>",
                    "<article class='flex'><a class='send-button fit' href='/contacto/' data-discover='true'>Póngase en contacto con nosotros para más información</a></article>"
                ]}
                modern="true"
            />
            <SeparatorLine />

            <TripleIconSection
                title="Transcripción y Traducción"
                textArray={[
                    "<p className='middle-section-label'><strong>Cuente con un equipo de transcriptores y traductores profesionales 24 horas al día, para convertir sus vídeos en texto.</strong></p>",
                    "<p className='middle-section-label'>Partiendo de sus grabaciones podemos hacernos cargo de todos sus trabajos de <strong>transcripción y traducción</strong>, independientemente de que estos hayan sido generados a través de Séneca. Realizamos los siguientes servicios:</p>"
                ]}
                iconArray={[

                    {
                        name: "bi bi-keyboard services-icon transcription-icon",
                        text: "<p className='middle-section-label'><strong>Transcripción:</strong> Convierta sus vídeos a texto.<p>"
                    }
                    ,

                    {
                        name: "bi bi-text-left services-icon align-icon",
                        text: "<p className='middle-section-label'><strong>Alineación:</strong> Subtitulación y CC, sus vídeos y textos alineados.<p>"
                    }
                    ,

                    {
                        name: "bi bi-translate services-icon translate-icon",
                        text: "<p className='middle-section-label'><strong>Traducción:</strong> El contenido de su vídeo en el idioma que precise.<p>"
                    }

                ]}
            />
            <SeparatorLine />

            <ImageSectionItem
                title="El proceso"
                imagePosition="after"
                layout="column"
                imageURL="/images/services/servicios-3.png"
                isAnimatedImage="true"
                isBigImage="true"
                imageClassName="process-image"
            />
            <SeparatorLine />

            <Link to="/contacto/" className="send-button fit mar-30">Póngase en contacto con nosotros para más información</Link>

            <IconTextSection
                imageURL="/images/services/servicios-4.png"
                title="Séneca On Cloud"
                textArray={[
                    "<p class='middle-section-label'><strong>Séneca On Cloud ofrece la posibilidad de desplegar la aplicación de Séneca garantizando la disponibilidad y escalabilidad de la solución sin preocuparse de la infraestructura.</strong></p>",
                    "<p class='middle-section-label'>Céntrese en generar el mejor contenido de vídeo, audio y material gráfico, y gestiónelo en la nube de la forma más sencilla y potente. El almacenamiento de datos se realiza sobre una plataforma con tecnología avanzada, realizando copias de seguridad periódicas y con la posibilidad de recuperación de la información. Además, incluye toda la conectividad precisa, servicio de migración y almacenamiento.</p>",
                    "<article class='flex jcenter'><a href='/documents/150511_Seneca-Datasheet-Saas_ok.pdf' target='_blank' rel='noopener noreferrer' className='send-button fit mar-30'>Ver Datasheet en PDF</a></article>"
                ]}
                v2="true"
            />

        </main>
    )
}

export default Services